import script from "./ProcessPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcessPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProcessPage.vue?vue&type=style&index=0&id=1bbb50fc&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bbb50fc"]])

export default __exports__